import { render, staticRenderFns } from "./record-dialog.vue?vue&type=template&id=2962e2a8&scoped=true&"
import script from "./record-dialog.vue?vue&type=script&lang=js&"
export * from "./record-dialog.vue?vue&type=script&lang=js&"
import style0 from "./record-dialog.vue?vue&type=style&index=0&id=2962e2a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2962e2a8",
  null
  
)

export default component.exports